module.exports = __webpack_public_path__ + "img/CLAMP-U.3dba14de.svg";